import { render } from "./ResultView.vue?vue&type=template&id=2aac4a26&scoped=true"
import script from "./ResultView.vue?vue&type=script&lang=js"
export * from "./ResultView.vue?vue&type=script&lang=js"

import "./ResultView.vue?vue&type=style&index=0&id=2aac4a26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aac4a26"]])

export default __exports__